import { RequireAccess } from '@/components'
import { FontPickerPage } from '@/managers'
import { SettingsNav } from '@/ui'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
	'/_auth/company/$companyId/settings/fonts',
)({
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<RequireAccess
			role="jobillan"
			fallback={<p className="text-sm text-gray-500 p-8">You do not have permission to access this page.</p>}
		>
			<SettingsNav active="fonts" fullWidth={true} fixedHeight={true}>
				<div className="h-full">
					<FontPickerPage />
				</div>
			</SettingsNav>
		</RequireAccess>
	)
}
